import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from "react";
import { ICourse } from "@types";
import { KeyedMutator } from "swr";

interface EmbedVideoAccessValue {
  courseData: ICourse;
  mutate: KeyedMutator<ICourse>;
}

interface Props {
  data: ICourse;
  mutate: KeyedMutator<ICourse>;
  children: ReactNode;
}

const EmbedVideoAccessContext = createContext<EmbedVideoAccessValue | null>(
  null
);

const EmbedVideoAccessProvider = ({ data, mutate, children }: Props) => {
  const [courseData, setCourseData] = useState<ICourse>(data);

  useEffect(() => {
    setCourseData(data);
  }, [data]);

  return (
    <EmbedVideoAccessContext.Provider value={{ courseData, mutate }}>
      {children}
    </EmbedVideoAccessContext.Provider>
  );
};

const useEmbedVideoAccessContext = () => {
  const context = useContext(EmbedVideoAccessContext);
  if (!context) {
    throw new Error(
      "useEmbedVideoAccessContext must be used within EmbedVideoAccessProvider"
    );
  }
  return context;
};

export { EmbedVideoAccessProvider, useEmbedVideoAccessContext };
